module.exports = __webpack_public_path__ + "static/img/mobile.512591e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/mobile.jpg
// module id = XdDU
// module chunks = 0